<script setup lang="ts">
import AuSkeletonWrapper from '~/components/ui/AuSkeletonWrapper.vue'
import AuSkeleton from '~/components/ui/AuSkeleton.vue'

const { color } = defineProps<{ color: string }>()
</script>

<template>
  <AuSkeletonWrapper class="col-[extext]">
    <AuSkeleton
      width="50%"
      height="40px"
      :background="color"
      class="mb-6"
    />
    <AuSkeleton
      v-for="i in 9"
      :key="i"
      :width="`${50 + Math.random() * 50}%`"
      height="20px"
      :background="color"
    />
    <AuSkeleton
      width="50%"
      height="40px"
      :background="color"
      class="mt-10 mb-6"
    />
    <AuSkeleton
      v-for="i in 9"
      :key="i"
      :width="`${50 + Math.random() * 50}%`"
      height="20px"
      :background="color"
    />
  </AuSkeletonWrapper>
</template>

<style scoped>

</style>
